import script from "./UserPasswordSetView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPasswordSetView.vue?vue&type=script&setup=true&lang=js"

import "./UserPasswordSetView.vue?vue&type=style&index=0&id=11b573bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b573bc"]])

export default __exports__